import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_dp28ag147e4p5cz as get_dp } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  title1ahgushtajx2d as title,
  body3i5t0n7zprpqb as body,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../../theming/Titles.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { space2ppi73m2qk1br as space } from '../../components/space.mjs';
import { get_expanding10cuv3ua9vajx as get_expanding } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import {
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  ContractorStatus_Approved_getInstance2o21n9qt09k9q as ContractorStatus_Approved_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  toDoSection277aoqfqgiijq as toDoSection,
  notificationBar4efejtg2792g as notificationBar,
} from '../../theming/banners.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../../utils/utils.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { align1ejncrrer3meh as align } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { contains2gm06f5aa19ov as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  await1kke5zj2piplv as await_0,
  rerunOn28vy04vs1j44i as rerunOn,
  awaitqeg6zusi9ora as await_1,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { DirectStatus_Verified_getInstancew10gjsxm5l1j as DirectStatus_Verified_getInstance } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { listOfNotNull1v4ggfackvuny as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { PaymentMethod1x8gg38hdlghq as PaymentMethod } from '../../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { SetupCustomerMethodDialog2y75086l50hfg as SetupCustomerMethodDialog } from '../../dialogs/SetupCustomerMethodDialog.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ClientPayments2dnqnm01pn8b5 as ClientPayments } from '../client/ClientPayments.mjs';
import { ContractorBankInfo3chkr569ztcs7 as ContractorBankInfo } from '../contractor/ContractorBankInfo.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generalToDos(_this__u8e3s4) {
  var isManager = remember(VOID, VOID, VOID, generalToDos$lambda);
  var isAdmin = remember(VOID, VOID, VOID, generalToDos$lambda_0);
  var pullMethods = BasicListenable().paq();
  var customerNeedsPaymentMethods = rememberSuspending(VOID, VOID, VOID, generalToDos$slambda_0(isManager, pullMethods));
  var paymentInfo = rememberSuspending(VOID, VOID, VOID, generalToDos$slambda_2());
  var contractorNeedsFinanceSetup = rememberSuspending(VOID, VOID, VOID, generalToDos$slambda_4(isAdmin, pullMethods, paymentInfo));
  var pendingMicroDepositVerification = rememberSuspending(VOID, VOID, VOID, generalToDos$slambda_6(isAdmin, pullMethods, paymentInfo));
  var approved = rememberSuspending(VOID, VOID, VOID, generalToDos$slambda_8(isManager, pullMethods));
  var todo = remember(VOID, VOID, VOID, ($this$remember) => {
    var n = 0;
    var tmp;
    if ($this$remember.daj(customerNeedsPaymentMethods)) {
      n = n + 1 | 0;
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($this$remember.daj(contractorNeedsFinanceSetup)) {
      n = n + 1 | 0;
      tmp_0 = Unit_instance;
    }
    var tmp_1;
    if ($this$remember.daj(pendingMicroDepositVerification)) {
      n = n + 1 | 0;
      tmp_1 = Unit_instance;
    }
    return n;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(0));
  view.jb7(false);
  var tmp = KMutableProperty0();
  var tmp_0 = RowOrCol$_get_shown_$ref_m8lfse(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RowOrCol$_set_shown_$ref_7290m6(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.daj(todo) > 0;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  title(view, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$2 = 'To-Do (' + $this$reactiveScope.daj(todo) + ')';
      this_0.set(tmp$ret$2);
      return Unit_instance;
    });
    return Unit_instance;
  });
  space(view, get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_dp(0));
  space(view_0, get_AppDimensions().ag2_1);
  var tmp_1 = get_expanding(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  var tmp_2 = toDoSection(view_1, Companion_getInstance().ccz(ProjectState_AwaitingFunding_getInstance().v9b_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  shownDefaultFalse(view_2, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(customerNeedsPaymentMethods));
  view_2.fba(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.lbb(notificationBar(view_3, AppColors_getInstance().kfz_1), body(view_3, 'You will need to connect your bank account to pass certain points of projects, you may connect them now to avoid this later.'));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Connect Bank Account';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_3 = view_4.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = content;
  }
  tmp_3.hbu(tmp_4);
  view_3.hbb(p_4, view_4);
  var tmp_5 = view_3.kbb(align(view_3, Align_Start_getInstance(), Align_Start_getInstance()), get_primaryButton(view_3));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Button())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  specCenteredText(view_5, 'Connect Bank Account');
  onClick(view_5, VOID, VOID, generalToDos$slambda_10(pullMethods));
  view_3.hbb(p_5, view_5);
  view_3.lbb(tmp_5, view_5);
  view_2.hbb(p_3, view_3);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_2, view_2);
  var tmp_6 = toDoSection(view_1, Companion_getInstance().ccz(ProjectState_AwaitingFunding_getInstance().v9b_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_6 = view_1.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
  view_1.gbb(p_6, view_6);
  shownDefaultFalse(view_6, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(contractorNeedsFinanceSetup));
  view_6.fba(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  view_7.zbm(true);
  view_7.lbb(notificationBar(view_7, AppColors_getInstance().kfz_1), body(view_7, 'You will need to connect your bank account to pass certain points of projects, you may connect them now to avoid this later.'));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_0 = 'Setup Contractor Finances';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  view_8.lba(view_8.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_7 = view_8.vb5_1;
  var tmp_8;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_0) === 0) {
    tmp_8 = '\xA0';
  } else {
    tmp_8 = content_0;
  }
  tmp_7.hbu(tmp_8);
  view_7.hbb(p_8, view_8);
  var tmp_9 = view_7.kbb(align(view_7, Align_Start_getInstance(), Align_Start_getInstance()), get_primaryButton(view_7));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Button())(view_7.pc());
  var tmp0_elvis_lhs_9 = view_7.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
  view_7.gbb(p_9, view_9);
  specCenteredText(view_9, 'Setup Finances');
  onClick(view_9, VOID, VOID, generalToDos$slambda_12(view_9));
  view_7.hbb(p_9, view_9);
  view_7.lbb(tmp_9, view_9);
  view_6.hbb(p_7, view_7);
  view_1.hbb(p_6, view_6);
  view_1.lbb(tmp_6, view_6);
  var tmp_10 = toDoSection(view_1, Companion_getInstance().ccz(ProjectState_AwaitingFunding_getInstance().v9b_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_10 = view_1.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
  view_1.gbb(p_10, view_10);
  shownDefaultFalse(view_10, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(pendingMicroDepositVerification));
  view_10.fba(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.zbm(true);
  view_11.lbb(notificationBar(view_11, AppColors_getInstance().kfz_1), body(view_11, 'Your bank account still needs to be confirmed before it can be used.'));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content_1 = 'Confirm Your Bank Account';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.gbb(p_12, view_12);
  view_12.lba(view_12.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_11 = view_12.vb5_1;
  var tmp_12;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content_1) === 0) {
    tmp_12 = '\xA0';
  } else {
    tmp_12 = content_1;
  }
  tmp_11.hbu(tmp_12);
  view_11.hbb(p_12, view_12);
  var tmp_13 = view_11.kbb(align(view_11, Align_Start_getInstance(), Align_Start_getInstance()), get_primaryButton(view_11));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (Button())(view_11.pc());
  var tmp0_elvis_lhs_13 = view_11.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
  view_11.gbb(p_13, view_13);
  specCenteredText(view_13, 'Confirm Bank Account');
  onClick(view_13, VOID, VOID, generalToDos$slambda_14(view_13));
  view_11.hbb(p_13, view_13);
  view_11.lbb(tmp_13, view_13);
  view_10.hbb(p_11, view_11);
  view_1.hbb(p_10, view_10);
  view_1.lbb(tmp_10, view_10);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_1, view_1);
  view.hbb(p_0, view_0);
  space(view, get_AppDimensions().ag2_1);
  _this__u8e3s4.hbb(p, view);
}
function generalToDos$lambda($this$remember) {
  var tmp = setOf([MemberRole_Admin_getInstance(), MemberRole_Manager_getInstance()]);
  var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfw_1).k88_1;
  return contains(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1);
}
function generalToDos$lambda_0($this$remember) {
  var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfw_1).k88_1;
  return equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1, MemberRole_Admin_getInstance());
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rj7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return false;
  var tmp_0 = rerunOn($this.sj7_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  println('Retrieving customer methods');
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_selectedContractor();
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (!(tmp_1 == null))
    return false;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2.vfw().dfh_1.mfs($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.also' call
  var this_3 = tmp_3;
  println('Got ' + this_3.p1() + ' methods');
  return this_3.i1();
}
var generalToDos$slambdaClass;
function generalToDos$slambda() {
  if (generalToDos$slambdaClass === VOID) {
    class $ {
      constructor($isManager, $pullMethods) {
        this.rj7_1 = $isManager;
        this.sj7_1 = $pullMethods;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    generalToDos$slambdaClass = $;
  }
  return generalToDos$slambdaClass;
}
function generalToDos$slambda_0($isManager, $pullMethods) {
  var i = new (generalToDos$slambda())($isManager, $pullMethods);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedContractor();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var contractorID = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1.vfw().off_1.sfi(contractorID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
var generalToDos$slambdaClass_0;
function generalToDos$slambda_1() {
  if (generalToDos$slambdaClass_0 === VOID) {
    class $ {
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    generalToDos$slambdaClass_0 = $;
  }
  return generalToDos$slambdaClass_0;
}
function generalToDos$slambda_2() {
  var i = new (generalToDos$slambda_1())();
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.tj7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return false;
  var tmp_0 = rerunOn($this.uj7_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.vj7_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var p = tmp_1;
  var tmp_2;
  if ((p == null ? null : p.b9u_1) == null) {
    tmp_2 = true;
  } else {
    tmp_2 = p.a9u_1 == null;
  }
  return tmp_2;
}
var generalToDos$slambdaClass_1;
function generalToDos$slambda_3() {
  if (generalToDos$slambdaClass_1 === VOID) {
    class $ {
      constructor($isAdmin, $pullMethods, $paymentInfo) {
        this.tj7_1 = $isAdmin;
        this.uj7_1 = $pullMethods;
        this.vj7_1 = $paymentInfo;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    generalToDos$slambdaClass_1 = $;
  }
  return generalToDos$slambdaClass_1;
}
function generalToDos$slambda_4($isAdmin, $pullMethods, $paymentInfo) {
  var i = new (generalToDos$slambda_3())($isAdmin, $pullMethods, $paymentInfo);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.wj7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return false;
  var tmp_0 = rerunOn($this.xj7_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.yj7_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_safe_receiver = tmp_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9u_1;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var info = tmp_2;
  return !info.e9v_1.equals(DirectStatus_Verified_getInstance());
}
var generalToDos$slambdaClass_2;
function generalToDos$slambda_5() {
  if (generalToDos$slambdaClass_2 === VOID) {
    class $ {
      constructor($isAdmin, $pullMethods, $paymentInfo) {
        this.wj7_1 = $isAdmin;
        this.xj7_1 = $pullMethods;
        this.yj7_1 = $paymentInfo;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    generalToDos$slambdaClass_2 = $;
  }
  return generalToDos$slambdaClass_2;
}
function generalToDos$slambda_6($isAdmin, $pullMethods, $paymentInfo) {
  var i = new (generalToDos$slambda_5())($isAdmin, $pullMethods, $paymentInfo);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zj7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!tmp)
    return false;
  var tmp_0 = rerunOn($this.aj8_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  println('Checking approval');
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1.vfw().dfh_1.aej($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var self_0 = tmp_2;
  // Inline function 'kotlin.collections.map' call
  var this_2 = listOfNotNull(self_0.k88_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_session();
    var tmp_3 = await_0(this_3, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp$ret$3 = tmp_3.lfv_1.geo(item.g8c_1);
    destination.v(tmp$ret$3);
  }
  var activeMembership = destination;
  var tmp_4;
  if (activeMembership.i1()) {
    tmp_4 = true;
  } else {
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_5;
      if (isInterface(activeMembership, Collection())) {
        tmp_5 = activeMembership.i1();
      } else {
        tmp_5 = false;
      }
      if (tmp_5) {
        tmp$ret$6 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = activeMembership.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element = _iterator__ex2g4s_0.o1();
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var tmp_6 = await_0(element, $completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        var tmp0_safe_receiver = tmp_6;
        if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r5j_1, ContractorStatus_Approved_getInstance())) {
          tmp$ret$6 = true;
          break $l$block_0;
        }
      }
      tmp$ret$6 = false;
    }
    tmp_4 = tmp$ret$6;
  }
  return tmp_4;
}
var generalToDos$slambdaClass_3;
function generalToDos$slambda_7() {
  if (generalToDos$slambdaClass_3 === VOID) {
    class $ {
      constructor($isManager, $pullMethods) {
        this.zj7_1 = $isManager;
        this.aj8_1 = $pullMethods;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    generalToDos$slambdaClass_3 = $;
  }
  return generalToDos$slambdaClass_3;
}
function generalToDos$slambda_8($isManager, $pullMethods) {
  var i = new (generalToDos$slambda_7())($isManager, $pullMethods);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.yb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var generalToDos$slambda$slambdaClass;
function generalToDos$slambda$slambda() {
  if (generalToDos$slambda$slambdaClass === VOID) {
    class $ {
      constructor($pullMethods) {
        this.bj8_1 = $pullMethods;
      }
      sgx($this$SetupCustomerMethodDialog, it, $completion) {
        println('Inside SetupMethodDialog onComplete');
        this.bj8_1.qaq();
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.sgx(tmp, p2 instanceof PaymentMethod() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    generalToDos$slambda$slambdaClass = $;
  }
  return generalToDos$slambda$slambdaClass;
}
function generalToDos$slambda$slambda_0($pullMethods) {
  var i = new (generalToDos$slambda$slambda())($pullMethods);
  var l = ($this$SetupCustomerMethodDialog, it, $completion) => i.sgx($this$SetupCustomerMethodDialog, it, $completion);
  l.$arity = 2;
  return l;
}
var generalToDos$slambdaClass_4;
function generalToDos$slambda_9() {
  if (generalToDos$slambdaClass_4 === VOID) {
    class $ {
      constructor($pullMethods) {
        this.cj8_1 = $pullMethods;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        tmp.zgd(new (SetupCustomerMethodDialog())(generalToDos$slambda$slambda_0(this.cj8_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    generalToDos$slambdaClass_4 = $;
  }
  return generalToDos$slambdaClass_4;
}
function generalToDos$slambda_10($pullMethods) {
  var i = new (generalToDos$slambda_9())($pullMethods);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = awaitOnce(get_selectedContractor(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!(tmp == null)) {
    get_pageNavigator($this.dj8_1).gbw(new (ContractorBankInfo())());
  } else {
    get_pageNavigator($this.dj8_1).gbw(new (ClientPayments())());
  }
  return Unit_instance;
}
var generalToDos$slambdaClass_5;
function generalToDos$slambda_11() {
  if (generalToDos$slambdaClass_5 === VOID) {
    class $ {
      constructor($$this$button) {
        this.dj8_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    generalToDos$slambdaClass_5 = $;
  }
  return generalToDos$slambdaClass_5;
}
function generalToDos$slambda_12($$this$button) {
  var i = new (generalToDos$slambda_11())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = awaitOnce(get_selectedContractor(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!(tmp == null)) {
    get_pageNavigator($this.ej8_1).gbw(new (ContractorBankInfo())());
  } else {
    get_pageNavigator($this.ej8_1).gbw(new (ClientPayments())());
  }
  return Unit_instance;
}
var generalToDos$slambdaClass_6;
function generalToDos$slambda_13() {
  if (generalToDos$slambdaClass_6 === VOID) {
    class $ {
      constructor($$this$button) {
        this.ej8_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    generalToDos$slambdaClass_6 = $;
  }
  return generalToDos$slambdaClass_6;
}
function generalToDos$slambda_14($$this$button) {
  var i = new (generalToDos$slambda_13())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  generalToDos as generalToDos3v1z2jqg8nvlm,
};
//endregion

//# sourceMappingURL=GeneralToDos.mjs.map
